import { observer } from 'mobx-react';
import * as React from 'react';
import { ParticipantResource } from '../../../../../../ParticipantsStore/Types';
import Row from './Row';
import { GroupParticipantsResource } from '../../../GroupParticipantsStore/Types';
import GroupParticipantsStore from '../../../GroupParticipantsStore/Store';

interface Props {
  participants: ParticipantResource[];
  groupParticipantsStore: GroupParticipantsStore;
  groupParticipantsResource: GroupParticipantsResource;
}

const Body: React.FC<Props> = ({
  participants,
  groupParticipantsResource,
  groupParticipantsStore,
}) => (
  <tbody className="divide-y divide-gray-200 bg-white">
    {participants.map((resource) => (
      <Row
        resource={resource}
        key={resource.payload.id}
        groupParticipantsStore={groupParticipantsStore}
        groupParticipantsResource={groupParticipantsResource}
      />
    ))}
  </tbody>
);

export default observer(Body);
